import { render, staticRenderFns } from "./CandidateCreate.vue?vue&type=template&id=7be71223&scoped=true&lang=pug"
import script from "./CandidateCreate.vue?vue&type=script&lang=js"
export * from "./CandidateCreate.vue?vue&type=script&lang=js"
import style0 from "./CandidateCreate.vue?vue&type=style&index=0&id=7be71223&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be71223",
  null
  
)

export default component.exports